/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  User Invitation Dialog
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStores } from 'stores/RootStore';
import AddressForm from 'components/Forms/AddressForm';

// Design System
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function AddLocation(props) {
  const { open } = props;
  const stores = useStores();
  const [name, setName] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');

  const handleChange = e => {
    if (e.target.id === 'name') {
      setName(e.target.value);
    } else if (e.target.name === 'Address1') {
      setAddress1(e.target.value);
    } else if (e.target.name === 'Address2') {
      setAddress2(e.target.value);
    } else if (e.target.name === 'City') {
      setCity(e.target.value);
    } else if (e.target.name === 'State') {
      setState(e.target.value);
    } else if (e.target.name === 'Zip') {
      setZip(e.target.value);
    }
  };

  const handleClose = e => {
    if (props.handleClose) {
      setName('');
      props.handleClose(e);
    }
  };

  const onSubmit = e => {
    e.preventDefault();

    const location = {
      name: name,
      address: {
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        zip: zip,
      },
    };

    stores.companyStore
      .addLocation(location)
      .then(() => {
        // Success
        handleClose();
      })
      .catch(error => {
        handleClose();
      });
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby='New Location'>
      <form autoComplete='off' action='' onSubmit={onSubmit}>
        <DialogTitle id='form-dialog-title'>New Location</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To setup a new location within your organization, please fill out the form below.
          </DialogContentText>
          <Grid container direction='row' alignItems='center'>
            <Grid item xs={12}>
              <TextField
                autoFocus
                margin='dense'
                id='name'
                label='Location Name'
                type='text'
                fullWidth
                required
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <AddressForm
                address1
                address2
                city
                state
                zip
                handleInputUpdate={handleChange}
                toStore={false}
                prefix={''}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Cancel
          </Button>
          <Button disabled={name === ''} color='primary' type='submit'>
            Add
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

AddLocation.propTypes = {
  handleClose: PropTypes.func,
};

export default AddLocation;
